import React from 'react';
import PropTypes from 'prop-types';

export const SmartphoneWithCamera = ({ width, height, ...props }) => (
  <svg
    data-icon='smartphone-with-camera'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 32 32'
    {...props}
  >
    <path
      fill='currentColor'
      d='M9.334 24v4V4v20ZM16 8c.378 0 .695-.128.95-.384a1.29 1.29 0 0 0 .384-.95 1.29 1.29 0 0 0-.384-.95 1.29 1.29 0 0 0-.95-.383 1.29 1.29 0 0 0-.95.383 1.29 1.29 0 0 0-.383.95c0 .378.128.695.383.95.256.256.572.384.95.384Zm6.667 16h2.667v4c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 0 1-1.883.783H9.334a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 6.667 28V4c0-.734.261-1.361.783-1.884a2.568 2.568 0 0 1 1.884-.783h13.333c.733 0 1.361.261 1.883.783.523.523.784 1.15.784 1.884v4h-2.667V4H9.334v24h13.333v-4Zm-3.333-2.667a1.929 1.929 0 0 1-1.417-.583 1.929 1.929 0 0 1-.583-1.417V14c0-.556.194-1.028.583-1.417A1.929 1.929 0 0 1 19.334 12h1.333L22 10.666h2.667L26 12h1.334c.555 0 1.027.194 1.416.583.39.389.584.861.584 1.417v5.333c0 .556-.195 1.028-.584 1.417a1.929 1.929 0 0 1-1.416.583h-8Zm4-2.333c.644 0 1.194-.228 1.65-.684a2.248 2.248 0 0 0 .683-1.65c0-.644-.228-1.194-.683-1.65a2.249 2.249 0 0 0-1.65-.683c-.645 0-1.195.228-1.65.683a2.248 2.248 0 0 0-.684 1.65c0 .645.228 1.195.684 1.65a2.248 2.248 0 0 0 1.65.684Z'
    />
  </svg>
);

SmartphoneWithCamera.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SmartphoneWithCamera.defaultProps = {
  width: 24,
  height: 24,
};
